// Tipi di scheda supportati dalla piattaforma.
export const TIPI = [
  { value: 'location', label: 'Location' },
  { value: 'animazione', label: 'Intrattenimento' },
  { value: 'allestimenti', label: 'Allestimenti' },
  { value: 'food', label: 'Food' },
];

const LABELS = { location: 'Location', animazione: 'Intrattenimento', allestimenti: 'Allestimenti', food: 'Food' };

export function tipoLabel(tipo) {
  return LABELS[tipo] || tipo;
}
